export function buildYears(
  currentYear: number,
  backYears: number,
  forwardYears: number
): number[] {
  const years: number[] = [];
  for (let y = currentYear + forwardYears; y >= currentYear - backYears; y--) {
    years.push(y);
  }
  return years;
}
